import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

const DistrictPage = () => {
  const { slug } = useParams();

  // Sayfa açıldığında en üste kaydır
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  const getDistrictName = (slugText) => {
    if (!slugText) return "İstanbul";
    const rawName = slugText.replace('-evden-eve-nakliyat', '');
    
    const names = {
      'arnavutkoy': 'Arnavutköy',
      'avcilar': 'Avcılar',
      'bagcilar': 'Bağcılar',
      'bahcelievler': 'Bahçelievler',
      'bakirkoy': 'Bakırköy',
      'basaksehir': 'Başakşehir',
      'bayrampasa': 'Bayrampaşa',
      'besiktas': 'Beşiktaş',
      'beylikduzu': 'Beylikdüzü',
      'beyoglu': 'Beyoğlu',
      'buyukcekmece': 'Büyükçekmece',
      'esenler': 'Esenler',
      'esenyurt': 'Esenyurt',
      'eyupsultan': 'Eyüpsultan',
      'fatih': 'Fatih',
      'gaziosmanpasa': 'Gaziosmanpaşa',
      'gungoren': 'Güngören',
      'kadikoy': 'Kadıköy',
      'kagithane': 'Kağıthane',
      'kucukcekmece': 'Küçükçekmece',
      'sultangazi': 'Sultangazi',
      'sisli': 'Şişli',
      'zeytinburnu': 'Zeytinburnu'
    };

    return names[rawName] || rawName.toUpperCase();
  };

  const districtName = getDistrictName(slug);

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh', 
      backgroundColor: '#f8fafc', 
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      clear: 'both' 
    }}>
      
      {/* 1. HERO (BAŞLIK) BÖLÜMÜ - YÜKSEK KONTRAST VE OKUNABİLİR METİN */}
      <div style={{ 
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%)', 
        color: '#ffffff', 
        padding: '60px 20px 90px 20px', 
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '850px', margin: '0 auto' }}>
          
          {/* ETIKET */}
          <span style={{ 
            backgroundColor: '#ffffff', 
            color: '#1d4ed8', 
            fontWeight: '700', 
            fontSize: '0.85rem', 
            padding: '8px 20px', 
            borderRadius: '50px', 
            display: 'inline-block',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            📍 {districtName.toUpperCase()} NAKLİYAT HİZMETİ
          </span>

          {/* ANA BAŞLIK */}
          <h1 style={{ 
            fontSize: '2.5rem', 
            fontWeight: '800', 
            marginBottom: '20px', 
            lineHeight: '1.25',
            color: '#ffffff',
            letterSpacing: '-0.5px'
          }}>
            {districtName} Evden Eve Nakliyat & Taşımacılık
          </h1>

          {/* DÜZELTİLEN VE NETLEŞTİRİLEN AÇIKLAMA METNİ */}
          <p style={{ 
            fontSize: '1.15rem', 
            color: '#ffffff', 
            fontWeight: '400',
            lineHeight: '1.7', 
            marginBottom: '35px',
            textShadow: '0 1px 2px rgba(0,0,0,0.2)'
          }}>
            DMNGL Nakliyat güvencesiyle <strong>{districtName}</strong> ve çevresinde sigortalı, ambalajlı ve asansörlü evden eve nakliyat hizmeti sunuyoruz. Eşyalarınız profesyonel ekibimizle tam zamanında ve hasarsız taşınır.
          </p>

          {/* BUTONLAR */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <a href="tel:05352439955" style={{ 
              backgroundColor: '#ffffff', 
              color: '#1d4ed8', 
              fontWeight: '800', 
              fontSize: '1.05rem',
              padding: '14px 32px', 
              borderRadius: '50px', 
              textDecoration: 'none',
              boxShadow: '0 6px 20px rgba(0,0,0,0.15)'
            }}>
              📞 0535 243 99 55
            </a>

            <Link to="/" style={{ 
              backgroundColor: 'rgba(255,255,255,0.15)', 
              color: '#ffffff', 
              fontWeight: '600', 
              fontSize: '1.05rem',
              padding: '14px 28px', 
              borderRadius: '50px', 
              textDecoration: 'none',
              border: '2px solid rgba(255,255,255,0.4)',
              backdropFilter: 'blur(5px)'
            }}>
              Ana Sayfaya Dön
            </Link>
          </div>

        </div>
      </div>

      {/* 2. ÖZELLİK KARTLARI */}
      <div style={{ maxWidth: '1140px', margin: '-50px auto 50px auto', padding: '0 20px', position: 'relative', zIndex: '2' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', width: '100%' }}>
          
          {/* Kart 1 */}
          <div style={{ 
            flex: '1 1 300px', 
            backgroundColor: '#ffffff', 
            borderRadius: '20px', 
            padding: '30px', 
            boxShadow: '0 10px 25px rgba(0,0,0,0.05)', 
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ 
              width: '56px', 
              height: '56px', 
              backgroundColor: '#eff6ff', 
              borderRadius: '14px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.8rem',
              marginBottom: '20px'
            }}>
              🛡️
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', marginBottom: '12px' }}>
              {districtName} Sigortalı Taşıma
            </h3>
            <p style={{ color: '#475569', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
              {districtName} içi nakliye süreçlerimizde tüm eşyalarınız olası kırılma, çizilme veya hasara karşı taşıma sigortası ile koruma altına alınır.
            </p>
          </div>

          {/* Kart 2 */}
          <div style={{ 
            flex: '1 1 300px', 
            backgroundColor: '#ffffff', 
            borderRadius: '20px', 
            padding: '30px', 
            boxShadow: '0 10px 25px rgba(0,0,0,0.05)', 
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ 
              width: '56px', 
              height: '56px', 
              backgroundColor: '#eff6ff', 
              borderRadius: '14px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.8rem',
              marginBottom: '20px'
            }}>
              🏗️
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', marginBottom: '12px' }}>
              {districtName} Asansörlü Nakliyat
            </h3>
            <p style={{ color: '#475569', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
              Dar merdivenli veya yüksek katlı binalarda modüler dış cephe asansörlerimizle eşyalarınızı bina içi yıpranma olmadan hızlıca indirip yüklüyoruz.
            </p>
          </div>

          {/* Kart 3 */}
          <div style={{ 
            flex: '1 1 300px', 
            backgroundColor: '#ffffff', 
            borderRadius: '20px', 
            padding: '30px', 
            boxShadow: '0 10px 25px rgba(0,0,0,0.05)', 
            border: '1px solid #e2e8f0'
          }}>
            <div style={{ 
              width: '56px', 
              height: '56px', 
              backgroundColor: '#eff6ff', 
              borderRadius: '14px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.8rem',
              marginBottom: '20px'
            }}>
              📦
            </div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0f172a', marginBottom: '12px' }}>
              {districtName} Ambalajlama
            </h3>
            <p style={{ color: '#475569', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
              Mobilyalarınız, beyaz eşyalarınız ve hassas mutfak eşyalarınız patpat baloncuklu ambalaj malzemeleri ve özel streçlerle özenle paketlenir.
            </p>
          </div>

        </div>
      </div>

      {/* 3. NEDEN BİZ BÖLÜMÜ */}
      <div style={{ maxWidth: '1140px', margin: '0 auto 60px auto', padding: '0 20px' }}>
        <div style={{ 
          backgroundColor: '#ffffff', 
          borderRadius: '20px', 
          padding: '40px', 
          border: '1px solid #e2e8f0',
          boxShadow: '0 4px 20px rgba(0,0,0,0.02)'
        }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#0f172a', marginBottom: '15px' }}>
            Neden {districtName} Nakliye Hizmetinde DMNGL Nakliyat?
          </h2>
          <p style={{ color: '#475569', fontSize: '1rem', lineHeight: '1.7', marginBottom: '25px' }}>
            Bahçelievler merkezli araç filomuz ve deneyimli nakliye ekibimiz sayesinde <strong>{districtName}</strong> bölgesindeki tüm nakliye taleplerinize en kısa sürede dönüş yapıyoruz. Müşteri memnuniyetini ön planda tutan şeffaf fiyat politikamız ile sürpriz ücretlerle karşılaşmadan güvenle taşınabilirsiniz.
          </p>

          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <div style={{ backgroundColor: '#f1f5f9', padding: '10px 18px', borderRadius: '10px', color: '#334155', fontWeight: '600', fontSize: '0.9rem' }}>
              ✅ Sabit Fiyat Garantisi
            </div>
            <div style={{ backgroundColor: '#f1f5f9', padding: '10px 18px', borderRadius: '10px', color: '#334155', fontWeight: '600', fontSize: '0.9rem' }}>
              ✅ Zamanında Teslimat
            </div>
            <div style={{ backgroundColor: '#f1f5f9', padding: '10px 18px', borderRadius: '10px', color: '#334155', fontWeight: '600', fontSize: '0.9rem' }}>
              ✅ K1 Belgeli Araç Filosu
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default DistrictPage;